(ns pfo.widget.tree
  (:require [reagent.core :as reagent :refer [atom]]))

(def tree-view (reagent/adapt-react-class js/TreeView))
